namespace TabAurous.OMS {
    export interface MarkUpPolicyForm {
        MarkUpPolicyCode: Serenity.StringEditor;
        MarkUpPolicyName: Serenity.StringEditor;
        Charges: MarkupChargesEditor;
    }

    export class MarkUpPolicyForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.MarkUpPolicy';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MarkUpPolicyForm.init)  {
                MarkUpPolicyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = MarkupChargesEditor;

                Q.initFormType(MarkUpPolicyForm, [
                    'MarkUpPolicyCode', w0,
                    'MarkUpPolicyName', w0,
                    'Charges', w1
                ]);
            }
        }
    }
}
